import script from "./BannersCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannersCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./BannersCarousel.vue?vue&type=style&index=0&id=5923addc&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5923addc"]])

export default __exports__